import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AlertService } from '../../../services/common/alert.service';
import { AppointmentRequestResultService } from '../../../services/appointment_requests/appointment-request-result.service';

import { Event } from '../../../models/event';

declare var moment: any;

@Component({
  selector: 'app-appointment-request-result-form',
  templateUrl: './appointment-request-result-form.component.html',
  styleUrls: ['./appointment-request-result-form.component.css'],
})
export class AppointmentRequestResultFormComponent implements OnInit {
  @Input() formOptions: any = {results: [], results_phone_number_not_required_for: []};
  @Input() attendees: any;
  @Input() eventType: string;
  @Input() appointmentRequestId: any;
  @Input() appointmentRequestResult: any;

  @Output() formSaved: EventEmitter<string> = new EventEmitter();

  phoneNumbers: Array<any>;
  eventPhoneNumbers: Array<any> = [];

  formSubmitted: boolean = false;
  formSubmitting: boolean;

  date: string;
  from_time: any;
  to_time: any;

  scheduleEvent: Event = new Event();

  constructor(private appointmentRequestResultService: AppointmentRequestResultService, private alertService: AlertService) {
    this.appointmentRequestResult = {};
  }

  ngOnInit() {
    if (!this.appointmentRequestResult.appointment_request_id) this.appointmentRequestResult.appointment_request_id = this.appointmentRequestId;
    if (this.appointmentRequestResult.attendee_id)
      for (var i in this.attendees) {
        var attendee = this.attendees[i];
        if (attendee.value == this.appointmentRequestResult.attendee_id) {
          this.phoneNumbers = attendee.phone_numbers;
        }
        for (var i in attendee.phone_numbers) {
          var phoneNumber = attendee.phone_numbers[i];
          if (phoneNumber.type_name.toLowerCase() != 'fax') this.eventPhoneNumbers.push(phoneNumber);
        }
      }
    else
      for (var i in this.attendees) {
        var attendee = this.attendees[i];
        for (var i in attendee.phone_numbers) {
          var phoneNumber = attendee.phone_numbers[i];
          if (phoneNumber.type_name.toLowerCase() != 'fax') this.eventPhoneNumbers.push(phoneNumber);
        }
      }
  }

  submitForm(formValid: boolean) {
    this.formSubmitted = true;
    if (formValid && this.formValidation()) {
      this.formSubmitting = true;
      var event = undefined;
      if (this.appointmentRequestResult.result == 'Schedule') {
        event = this.scheduleEvent;
        event.start = moment(`${this.date} ${this.from_time.hour}:${this.from_time.minute}`, 'MM/DD/YYYY HH:mm').toISOString();
        event.end = moment(`${this.date} ${this.to_time.hour}:${this.to_time.minute}`, 'MM/DD/YYYY HH:mm').toISOString();
        if (event.phone_number_id)
          for (var i in this.eventPhoneNumbers) {
            var phoneNumber = this.eventPhoneNumbers[i];
            if (phoneNumber.value == event.phone_number_id) {
              event.phone_contact_id = phoneNumber.contact_id;
              break;
            }
          }
      }
      if (this.appointmentRequestResult.id)
        this.appointmentRequestResultService
          .updateAppointmentRequestResult(this.appointmentRequestResult.id, {
            appointment_request_result: this.appointmentRequestResult,
            schedule_event: event,
          })
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) {
              if (response_json.text.toLowerCase().indexOf('outgoing error') > -1) this.alertService.alert_status_danger(response_json.text);
              else {
                this.alertService.alert_status_success(response_json.text);
                this.formSaved.emit(response_json.text);
              }
            } else this.alertService.alert_status_danger('Error updating appointment request result');
          });
      else
        this.appointmentRequestResultService
          .createAppointmentRequestResult({
            appointment_request_result: this.appointmentRequestResult,
            schedule_event: event,
          })
          .then((response_json) => {
            this.formSubmitting = false;
            if (response_json && response_json.text) {
              if (response_json.text.toLowerCase().indexOf('outgoing error') > -1) this.alertService.alert_status_danger(response_json.text);
              else {
                this.alertService.alert_status_success(response_json.text);
                this.formSaved.emit(response_json.text);
              }
            } else this.alertService.alert_status_danger('Error creating appointment request result');
          });
    }
  }

  formValidation() {
    if (this.formOptions.results_attendee_not_required_for.indexOf(this.appointmentRequestResult.result) < 0) if (!this.appointmentRequestResult.attendee_id) return false;
    if (this.formOptions.results_phone_number_not_required_for.indexOf(this.appointmentRequestResult.result) < 0) {
      if (!this.appointmentRequestResult.phone_number) return false;
      if (this.appointmentRequestResult.result.toLowerCase() == 'schedule' && !this.scheduleEvent.phone_number_id) return false;
    }
    return true;
  }

  fieldShowErrorMessage(field: any) {
    if (!field.valid && this.formSubmitted) return true;
    else return false;
  }

  onAttendeeSelect(attendee_id: number) {
    for (var i in this.attendees) {
      var attendee = this.attendees[i];
      if (attendee.value == attendee_id) {
        this.phoneNumbers = attendee.phone_numbers;
        break;
      }
    }
  }

  showAttendeeRequiredError(attendee_id_field: any) {
    if (!attendee_id_field.model && this.formSubmitted && this.formOptions.results_attendee_not_required_for.indexOf(this.appointmentRequestResult.result) < 0) return true;
    else return false;
  }

  showPhoneNumberRequiredError(phone_number_field: any) {
    if (!phone_number_field.model && this.formSubmitted && this.formOptions.results_phone_number_not_required_for.indexOf(this.appointmentRequestResult.result) < 0) return true;
    else return false;
  }

  defaultToTime() {
    return new Date(Number(new Date()) + 1000 * 1800);
  }

  onDateSelect(date_str: string) {
    this.date = date_str;
  }

  onTimeSelect(time_result: any, type: string) {
    if (type == 'from') this.from_time = time_result;
    else if (type == 'to') this.to_time = time_result;
  }
}
